import { getAccessToken } from "../storage/accessTokenStorage";
import { doAutoSuggestGet } from "../../actions/thunks/schemaThunks";

const dispatchAutoSuggest = (component) => {
  const accessToken = getAccessToken();
  let autoSuggestEndpoint = "";
  for (let property in component.props.autoSuggestEndpoints) {
    if (component.props.autoSuggestEndpoints.hasOwnProperty(property)) {
      autoSuggestEndpoint = component.props.autoSuggestEndpoints[property];
      component.props.dispatch(
        doAutoSuggestGet({
          id: component.props.id,
          accessToken,
          endpoint: autoSuggestEndpoint,
          property,
        })
      );
    }
  }
};

export default dispatchAutoSuggest;
